import React from 'react';
import PropTypes from 'prop-types';
import SimpleDropdown from '../dropdown/SimpleDropdown';

const TypeDropdown = ({ types, value, onChange, className, dropdownClassName, disabled, placeholder }) => {
    const itemList = types.map(opt => ({ id: opt.type, text: opt.text }));
    const selectedItem = value
        ? itemList.find(item => item.id === value)
        : { id: '__placeholder__', text: placeholder };

    return (
        <SimpleDropdown
            onItemClick={onChange}
            items={itemList}
            selectedItem={selectedItem}
            name="filter-type-dropdown"
            selectedItemClassName={className}
            className={dropdownClassName}
            disabled={disabled}
            filterPlaceholder={placeholder}
        />
    );
};

TypeDropdown.propTypes = {
    onChange: PropTypes.func.isRequired,
    types: PropTypes.array.isRequired,
    value: PropTypes.string,
    className: PropTypes.string,
    dropdownClassName: PropTypes.string,
    disabled: PropTypes.bool,
    placeholder: PropTypes.string,
};

TypeDropdown.defaultProps = {
    value: undefined,
    className: '',
    dropdownClassName: '',
    disabled: false,
};

export default TypeDropdown;
